import styled from '@emotion/styled'
import { transparentize } from 'polished'

import { Color } from '../../../../enums/color'
import { getShadow } from '../../../../utils/getShadow'
import { zIndex } from '../../../../utils/zIndex'
import { AspectRatio } from '../../types'

interface FullScreenWrapperProps {
  visible?: boolean
  withOverlay?: boolean
}

export const FullScreenWrapper = styled.div<FullScreenWrapperProps>`
  display: flex;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${zIndex.Modal};
  background-color: ${({ withOverlay }) =>
    withOverlay ? transparentize(0.6, Color.Grey950) : transparentize(1, Color.Grey950)};
  pointer-events: ${({ visible }) => (visible ? 'all' : 'none')};
  transition: opacity 0.3s ease-out;

  ${() => ModalWrapper} {
    transform: ${({ visible }) => (visible ? 'translateY(0)' : 'translateY(30px)')};
  }
`

interface ModalWrapperProps {
  visible?: boolean
}

export const ModalWrapper = styled.div<ModalWrapperProps>`
  display: ${(props) => (props.visible ? 'flex' : 'none')};
  justify-content: center;
  width: 75vw;
  height: 75vh;
  margin: auto;
  padding: 10px;
  border-radius: 8px;
  position: relative;
  background-color: ${Color.White};
  transition: transform 0.3s ease-out;
  ${getShadow('elevatedLight')}
`

export const CloseWrapper = styled.div`
  position: absolute;
  top: -40px;
  right: 0;
  cursor: pointer;
`

interface FilesPreviewContentContainerProps {
  aspectRatio?: AspectRatio
}

export const FilesPreviewContentContainer = styled.div<FilesPreviewContentContainerProps>`
  display: flex;
  aspect-ratio: ${({ aspectRatio }) => aspectRatio ?? 'auto'};
`
